<template>
  <div class="grid" :style="gridVars">
    <div class="myRow myRow--top">
      <!--      Obere Zeile (60%)-->

      <div v-if="height>1200"
           style="width: 100vw;overflow: hidden; height: 1100px">
        <SliderImages :tablet="true"></SliderImages>
      </div>
      <div v-else
           style="width: 100vw;overflow: hidden; height: 350px">
        <SliderImages :tablet="true" :densed="true"></SliderImages>
      </div>
    </div>
    <div class="myRow myRow--mid">
      <!--    >Mittlere Zeile (40%)-->
      <div>
        <table class="table-collapse">
          <tr>
            <td>
              <div>
                <PunkteSammelBox></PunkteSammelBox>
              </div>
            </td>
            <td>
              <div style="width: 40px"></div>
            </td>
            <td>
              <div @click="startOrder">
                <StarteBestellungButton></StarteBestellungButton>
              </div>
            </td>
            <td>
              <div>
                <SprachAuswahl></SprachAuswahl>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="myRow myRow--bottom">
      <!--      Untere Zeile (200px)-->
      <div>
        <Zahlungsarten :noborder="true" :nopadding="true"></Zahlungsarten>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/store";
import SliderImages from "../components/SliderImages.vue";
import Zahlungsarten from "../components/Zahlungsarten.vue";
import StarteBestellungButton from "./StarteBestellungButton.vue";
import PunkteSammelBox from "./PunkteSammelBox.vue";
import SprachAuswahl from "../components/SprachAuswahl.vue";
import {fullscreenMode} from "../vendor/util";

export default {
  name: 'ThreeRowGrid',
  components: {SprachAuswahl, PunkteSammelBox, StarteBestellungButton, Zahlungsarten, SliderImages},
  props: {
    topHeight: {type: String, default: '1100px'},
    midPercent: {type: Number, default: 40},
    bottomHeight: {type: String, default: '200px'},
    gap: {type: String, default: '0'}
  },
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  },
  computed: {
    gridVars() {
      return {
        '--top-height': this.height > 1200 ? this.topHeight : 350,
        // '--mid-percent': this.midPercent.toString(),
        '--bottom-height': this.bottomHeight,
        '--gap': this.gap
      };
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    if (!store.getters.isKiosk) {
      this.$router.replace({name: 'Home'});
      return;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    startOrder() {
      // fullscreenMode(true);
      this.$router.push({name: 'KioskUseCaseSelection'});
      // this.$router.replace({name: 'Sortiment'});
      // this.$router.push({name: 'Sortiment'});
    }
  },
}
</script>

<style scoped lang="scss">

.wrapperMid {
  background: green;
}

.grid {
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  //max-height: 100vh;
  display: grid;
  /* WICHTIG: "minmax(0, 1fr)" sorgt dafür, dass die mittlere Reihe den verbleibenden Platz
  einnimmt und nicht durch min-content / overflow eingeschränkt wird. */
  grid-template-rows: var(--top-height) minmax(0, 1fr) var(--bottom-height);
  gap: var(--gap);

  //grid-template-rows:
  //  calc(var(--top-percent) * ((100vh - var(--bottom-height)) / 100))
  //  calc(var(--mid-percent) * ((100vh - var(--bottom-height)) / 100))
  //  var(--bottom-height);
}

.myRow {
  display: flex;
  align-items: center;
  justify-content: center;
  //padding: 1rem;
  box-sizing: border-box;
  //border: 1px solid rgba(0,0,0,0.06);
}

.myRow--top {
  background: white;
}

//.myRow--top { background: rgba(135,206,250,0.15); }
.myRow--mid {
  background: white;
}

.myRow--bottom {
  border-radius: 25px 25px 0 0;
  background: black;

  h4 {
    color: white !important;
  }
}
</style>
